import type { UnitInfoPlateFeederInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import type { PlateFeederSHUnitInfoDataMapInterface } from './unitInfoData';

export const filterModels = (models: string[], mining: boolean): string[] => {
  if (mining) {
    return models.filter((m) => m.substring(m.length - 1) !== '2');
  } else {
    return models.filter((m) => m.substring(m.length - 1) === '2');
  }
};

export const getDefaultData = (
  _unitInfoData: PlateFeederSHUnitInfoDataMapInterface,
): UnitInfoPlateFeederInterface => {
  return {
    modelName: 'SH1042',
    moisture: 0,
    newMoisture: false,
    mining: false,
    parallelUnits: 1,
    otherModel: false,
    otherModelMaxCapacity: 0,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayLoad: true,
      displayNominalCapacityRange: false,
    },
  };
};

export class PlateFeederSHConfig extends BaseUnitConfig {
  static getDefaultData(
    _params?: UnitConfigParams,
  ): UnitInfoPlateFeederInterface {
    return {
      modelName: 'SH1042',
      ...BaseUnitConfig.getBaseDefaults(),
      mining: false,
      otherModel: false,
      otherModelMaxCapacity: 0,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayLoad: true,
        displayNominalCapacityRange: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 2;
  }
}

export const plateFeederSHConfig = new PlateFeederSHConfig();
